<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Logs de Codeco</h3>
            </div>
            <div class="layout__controls">
                <div class="form-inline">
                    <button type="button" @click="consultar" class="btn-info btn--bigger"><i class="fa fa-search"></i><span>Consultar</span></button>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h3>Filtros de la consulta</h3>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select">
                            <div class="select-field">
                                <select name="tipo_fecha" v-model="form.tipo_fecha" id="tipo_fecha">
                                    <option value="H">Hoy</option>
                                    <option value="A">Ayer</option>
                                    <option value="P">Personalizada</option>
                                </select>
                                <label for="tipo_fecha">Tipo de fecha</label>
                            </div>
                        </div>
                    </div>
                    <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field datepicker-field--stretch">
                                <date-picker @enterkey="consultar" type="date" id="desde" v-model="form.desde"></date-picker>
                                <label>{{ $t('message.desde') }}</label>
                            </div>
                        </div>
                    </div>
                    <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field datepicker-field--stretch">
                                <date-picker @enterkey="consultar" type="hasta" id="hasta" v-model="form.hasta"></date-picker>
                                <label>{{ $t('message.hasta') }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <input-field @keyup.enter="consultar"  id="numero_contenedor" v-model="form.numero_contenedor" placeholder="Consulte por número de contenedor...">
                                # Contenedor
                            </input-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mt-2">
            <div class="card__title">
                <h5>Consulta</h5>
            </div>
            <div class="card__content">
                <k-table 
                    noForms
                    :params="form"
                    :mostrarTodos="false"
                    :columns="[
                        {
                            display : 'Fecha',
                            value : 'created_at'
                        },
                        {
                            display : '# Contenedor',
                            value : 'numero_contenedor'
                        },
                        {
                            display : 'Mensaje',
                            value : 'mensaje'
                        },
                        {
                            display : 'Archivo',
                            value : 'archivo'
                        },
                        {
                            display : 'Procesado',
                            value : 'realizado'
                        }
                    ]"
                    :path="path"
                    ref="logsCodeco"
                    :deleteButton="false" 
                    :createButton="false" 
                    :editButton="false">
                </k-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            form: {
                desde: moment(new Date()).format('YYYY-MM-DD'),
                hasta: moment(new Date()).format('YYYY-MM-DD'),
                tipo_fecha: 'H',
                numero_contenedor: ''
            },
            path: url + '/logs-codeco'
        };
    },
    methods: {
        consultar: function () {
            this.$refs.logsCodeco.loadRows();
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/LogsCodeco.vue